/* ms-pack-split — Malara® (nov 2026)
   Cuando cualquier botón agrega un PACK al carrito (/cart/add), esta capa cambia
   la petición para que entren sus perfumes de 100 ml como piezas separadas, cada
   una con la propiedad "Pack". Así Kite y Monster Cart los cuentan en la escalera
   4 → 8 → 11 junto con los sueltos. El mapa pack → perfumes lo pinta
   snippets/ms-pack-split.liquid desde el metacampo custom.pack_componentes.

   Después de separar un pack se llama a window.monster_refresh (la función pública
   de Monster Cart) para que vuelva a leer el carrito y pinte metas y regalos. */
(function () {
  var MAP = window.MalaraPackMap || {};
  if (!Object.keys(MAP).length || window.__msPackSplit) return;
  window.__msPackSplit = true;

  function isAdd(url) {
    try {
      var u = String(url && url.url ? url.url : url).split('#')[0];
      return /\/cart\/add(\.js|\.json)?(\?|$)/.test(u);
    } catch (e) {
      return false;
    }
  }

  function expand(items) {
    var out = [];
    var changed = false;
    items.forEach(function (it) {
      var p = MAP[String(it.id || it.variant_id || '')];
      if (!p) {
        out.push(it);
        return;
      }
      changed = true;
      var q = parseInt(it.quantity, 10) || 1;
      var props = Object.assign({}, it.properties || {}, { Pack: p.n });
      var agg = {};
      p.ids.forEach(function (v) {
        agg[v] = (agg[v] || 0) + q;
      });
      Object.keys(agg).forEach(function (v) {
        out.push({ id: Number(v), quantity: agg[v], properties: props });
      });
    });
    return changed ? out : null;
  }

  function fromForm(fd) {
    var id = fd.get('id');
    if (!id || !MAP[String(id)]) return null;
    var props = {};
    fd.forEach(function (val, key) {
      var m = String(key).match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = val;
    });
    var body = { items: expand([{ id: id, quantity: fd.get('quantity') || 1, properties: props }]) };
    if (fd.get('sections')) body.sections = fd.get('sections');
    if (fd.get('sections_url')) body.sections_url = fd.get('sections_url');
    return body;
  }

  function transform(body) {
    try {
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var b1 = fromForm(body);
        return b1 ? JSON.stringify(b1) : null;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var b2 = fromForm(body);
        return b2 ? JSON.stringify(b2) : null;
      }
      if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') {
          var j = JSON.parse(s);
          if (Array.isArray(j.items)) {
            var e1 = expand(j.items);
            if (!e1) return null;
            j.items = e1;
            return JSON.stringify(j);
          }
          if (j.id) {
            var e2 = expand([{ id: j.id, quantity: j.quantity, properties: j.properties }]);
            if (!e2) return null;
            var nb = { items: e2 };
            if (j.sections) nb.sections = j.sections;
            if (j.sections_url) nb.sections_url = j.sections_url;
            return JSON.stringify(nb);
          }
          return null;
        }
        var b3 = fromForm(new URLSearchParams(s));
        return b3 ? JSON.stringify(b3) : null;
      }
    } catch (err) {
      console.warn('[ms-pack-split]', err);
    }
    return null;
  }

  function refreshMonster() {
    try {
      if (typeof window.monster_refresh === 'function') {
        window.monster_refresh(true);
      }
    } catch (e) {}
  }

  function notify() {
    try {
      document.dispatchEvent(new CustomEvent('ms:pack-split'));
    } catch (e) {}
    setTimeout(refreshMonster, 250);
  }

  function wrapFetch() {
    var prev = window.fetch;
    if (!prev || prev.__msPackSplit) return;
    var wrapped = function (input, init) {
      var split = false;
      try {
        if (isAdd(input) && init && init.body) {
          var nb = transform(init.body);
          if (nb) {
            var h = new Headers(init.headers || {});
            h.set('Content-Type', 'application/json');
            if (!h.has('Accept')) h.set('Accept', 'application/json');
            init = Object.assign({}, init, { body: nb, headers: h });
            split = true;
          }
        }
      } catch (e) {}
      var p = prev.call(this, input, init);
      if (split && p && p.then) p.then(notify, function () {});
      return p;
    };
    wrapped.__msPackSplit = true;
    window.fetch = wrapped;
  }

  function wrapXHR() {
    var XP = XMLHttpRequest.prototype;
    if (XP.send.__msPackSplit) return;
    var _open = XP.open;
    var _send = XP.send;
    var _setH = XP.setRequestHeader;
    XP.open = function (method, url) {
      this.__msAdd = isAdd(url);
      this.__msCT = null;
      return _open.apply(this, arguments);
    };
    XP.setRequestHeader = function (name, value) {
      if (this.__msAdd && String(name).toLowerCase() === 'content-type') {
        this.__msCT = value;
        return;
      }
      return _setH.apply(this, arguments);
    };
    var send = function (body) {
      if (this.__msAdd) {
        var nb = transform(body);
        if (nb) {
          _setH.call(this, 'Content-Type', 'application/json');
          body = nb;
          this.addEventListener('load', notify);
        } else if (this.__msCT) {
          _setH.call(this, 'Content-Type', this.__msCT);
        }
      }
      return _send.call(this, body);
    };
    send.__msPackSplit = true;
    XP.send = send;
  }

  function install() {
    wrapFetch();
    wrapXHR();
  }

  install();
  document.addEventListener('DOMContentLoaded', install);
  window.addEventListener('load', function () {
    install();
    setTimeout(install, 1500);
    setTimeout(install, 4000);
  });
})();
